import { useState, useEffect, useCallback } from 'react'
import * as contractsApi from '@/services/api/contracts'
import type { ContractPerformance } from '@/services/api/contracts'

interface UseContractPerformanceParams {
  year?: number
  type?: 'buy' | 'sale'
  enabled?: boolean
}

export function useContractPerformance(params: UseContractPerformanceParams = {}) {
  const { year, type, enabled = true } = params
  const [data, setData] = useState<ContractPerformance | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchPerformance = useCallback(async () => {
    if (!enabled) {
      setLoading(false)
      return
    }
    try {
      setLoading(true)
      setError(null)
      const result = await contractsApi.getContractPerformance({
        year,
        type,
      })
      setData(result)
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to fetch contract performance')
      setData(null)
    } finally {
      setLoading(false)
    }
  }, [enabled, year, type])

  useEffect(() => {
    fetchPerformance()
  }, [fetchPerformance])

  return { data, loading, error, refetch: fetchPerformance }
}
